import { ArrowDown, ArrowRight } from './icons'
import { Reveal } from '../hooks/useReveal'

export const Header = ({ company }) => {
  const [first, ...rest] = company.name.split(' ')

  return (
    <header className="hero" id="top">
      <div className="container hero__grid">
        <Reveal>
          <p className="status">
            <span className="status__dot" aria-hidden="true" />
            {company.status}
          </p>

          <h1 className="hero__name">
            {first} <em>{rest.join(' ')}</em>
          </h1>

          <p className="hero__role">{company.role}</p>

          <p className="hero__headline">{company.headline}</p>

          <div className="hero__actions">
            <a className="btn btn--primary" href="#work">
              See the products
              <ArrowDown className="btn__arrow" />
            </a>
            {company.email && (
              <a className="btn btn--ghost" href="#contact">
                Get in touch
                <ArrowRight className="btn__arrow" />
              </a>
            )}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="panel">
            <div className="panel__bar">
              <span className="panel__dots" aria-hidden="true">
                <i />
                <i />
                <i />
              </span>
              byte-visions
            </div>

            <dl className="panel__body">
              {company.meta.map((item) => (
                <div className="meta-row" key={item.label}>
                  <dt>{item.label}</dt>
                  <dd>{item.value}</dd>
                </div>
              ))}
            </dl>

            <div className="panel__foot">
              <p className="panel__label">Platforms</p>
              <ul className="top-skills">
                {company.platforms.map((skill) => (
                  <li className="top-skill" key={skill}>
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </header>
  )
}
